module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<ul class="pagination animated fadeInUp wow">\r\n    <li><span class="iconfont icon-left"></span></li>\r\n    <li class="active">\r\n        <span>1</span>\r\n    </li>\r\n    <li>\r\n        <a href="/index/index/news?lang=FN&amp;page=2">2</a>\r\n    </li>\r\n    <li>\r\n        <a href="/index/index/news?lang=FN&amp;page=2">3</a>\r\n    </li>\r\n    <li>\r\n        <a href="/index/index/news?lang=FN&amp;page=2">4</a>\r\n    </li>\r\n    <li>\r\n        <a href="/index/index/news?lang=FN&amp;page=2">\r\n            <span class="iconfont icon-right"></span>\r\n        </a>\r\n    </li>\r\n</ul>\r\n';

}
return __p
}